import {MessageBase} from './message-base';
import {CHART_TYPE} from '../DoraData/data-base';

export class MessageChartType extends MessageBase<MessageChartType> {
    // tslint:disable-next-line:variable-name
    private _chartType: CHART_TYPE;

    constructor(type: CHART_TYPE) {
        super(MessageChartType);

        this._chartType = type;
    }


    public get chartType(): CHART_TYPE {
        return this._chartType;
    }
}
